import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { useAccount } from '../contexts/AccountContext';
const links = [{
  label: 'Collection',
  hash: '#collection'
}, {
  label: 'Material',
  hash: '#materials'
}, {
  label: 'Atelier',
  hash: '#atelier'
}];
export function Header() {
  const {
    count,
    openCart
  } = useCart();
  const {
    openAccount
  } = useAccount();
  const {
    pathname
  } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const isHome = pathname === '/';
  const solid = !isHome || scrolled || menuOpen;
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);
  const href = (hash: string) => isHome ? hash : `/${hash}`;
  return <header className={`fixed inset-x-0 top-0 z-40 transition-colors duration-500 ${solid ? 'bg-bone/95 backdrop-blur-sm border-b border-greige/70' : 'bg-transparent'}`} data-id="element-121" data-mp="2rm17qy7wrm4j">
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-5 lg:px-12" data-id="element-122" data-mp="2hntw8uwe1w9x">
        <nav aria-label="Primary" className="hidden flex-1 items-center gap-9 lg:flex" data-id="element-123" data-mp="3fb2m123f9rhq">
          {links.map(link => <a key={link.label} href={href(link.hash)} className="eyebrow text-smoke transition-colors hover:text-ink" data-id="element-124" data-mp="3adajzf92cozt">
              {link.label}
            </a>)}
        </nav>

        <button type="button" onClick={() => setMenuOpen(v => !v)} aria-expanded={menuOpen} aria-label={menuOpen ? 'Close menu' : 'Open menu'} className="flex h-9 w-9 items-center justify-center text-ink lg:hidden" data-id="element-125" data-mp="30kd83ryktya6">
          {menuOpen ? <XIcon size={18} strokeWidth={1.25} data-id="element-126" data-mp="1recw7j1dczlk" /> : <MenuIcon size={18} strokeWidth={1.25} data-id="element-127" data-mp="1wcee40n26svg" />}
        </button>

        <Link to="/" className="font-display text-2xl font-light tracking-[0.3em] text-ink lg:flex-1 lg:text-center" data-id="element-128" data-mp="1weqzkns0zld9">
          TENZY&nbsp;CLUB
        </Link>

        <div className="flex flex-1 items-center justify-end gap-6" data-id="element-129" data-mp="1ml07za0lqutc">
          <button type="button" onClick={() => openAccount('signin')} className="eyebrow hidden text-smoke transition-colors hover:text-ink lg:inline" data-id="element-130" data-mp="18m0pyl7lhe65">
            Account
          </button>
          <button type="button" onClick={openCart} className="eyebrow text-ink transition-opacity hover:opacity-60" data-id="element-131" data-mp="yr08h5jh2lqo">
            Bag ({count})
          </button>
        </div>
      </div>

      {menuOpen && <nav aria-label="Mobile" className="border-t border-greige/70 px-6 py-4 lg:hidden" data-id="element-132" data-mp="2y0yqs5ll0v7r">
          <ul className="space-y-3" data-id="element-133" data-mp="mfptuac7twl3">
            {links.map(link => <li key={link.label} data-id="element-134" data-mp="hftpub3iq55j">
                <a href={href(link.hash)} onClick={() => setMenuOpen(false)} className="eyebrow block text-smoke" data-id="element-135" data-mp="hgwd891mtpgp">
                  {link.label}
                </a>
              </li>)}
            <li data-id="element-136" data-mp="154mncbzsgl29">
              <button type="button" onClick={() => {
            setMenuOpen(false);
            openAccount('signin');
          }} className="eyebrow block text-smoke" data-id="element-137" data-mp="1544k2vepl6ku">
                Account
              </button>
            </li>
          </ul>
        </nav>}
    </header>;
}